exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iframe-container {\n  position: fixed;\n  top: 20px;\n  left: 20px;\n  bottom: 20px;\n  right: 20px;\n  overflow: auto;\n  height: calc(100vh - 40px);\n  width: calc(100vw - 40px);\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 1000;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  border: 1px solid #000;\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: red;\n  color: white;\n  border: none;\n  padding: 4px 8px;\n  cursor: pointer;\n  z-index: 1001;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\niframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/utils/fullscreen/full-screen-iframe.component.css
// module id = ../../../../../src/app/components/utils/fullscreen/full-screen-iframe.component.css
// module chunks = main